import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {CellComponent} from '@shared/components/cell-components/cell-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {FieldDefinition} from '@shared/models/field-definition';
import {Router} from '@angular/router';

@Component({
    standalone: false,
    selector: 'particle-data-survey-cell-editor',
  templateUrl: './data-survey-cell-editor.component.html',
  styleUrls: ['./data-survey-cell-editor.component.scss']
})
export class DataSurveyCellEditorComponent implements OnInit, CellComponent {
  invalidateSubject?: InvalidateSubject;
  item: any;
  fieldDefinition: FieldDefinition;
  sourceType: string;
  @Output() valueChanged: EventEmitter<any> = new EventEmitter();
  icon: string;
  disabled: boolean;
  constructor(private router: Router) { }

  ngOnInit() {
  }
  onClicked(action: string) {
    this.valueChanged.emit({item: this.item, fieldDefinition: this.fieldDefinition, action: {id: action}});
  }
}
